var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEthereumColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "0 0 256 427"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5A9DED",
    d: "M256 241.65L128 426.8V322.457l128-80.807zm-67.84 65.08l-41.09 25.858v33.473l41.09-59.33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#53D3E0",
    d: "M0 241.65L128 426.8V322.457L0 241.65zm67.84 65.08l41.09 25.858v33.473l-41.09-59.33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D995D1",
    d: "M144.238 156.998l84.775 47.215 3.005 9.187-10.094 8.812-77.686-43.358z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6E276",
    d: "M111.818 156.998l-84.775 47.215-3.005 9.187 10.094 8.812 77.686-43.358z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9C92",
    d: "M128 0l128 219.203-128 80.608V0zm18.904 70.317V266.03l83.622-52.631-83.622-143.083z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE94D",
    d: "M128 0L0 219.203l128 80.608V0zm-18.904 70.317V266.03L25.474 213.4l83.622-143.083z"
  })));
}

export default SvgEthereumColored;